import _ from 'lodash';

export default (multibookType) => {
  const gamesData = require(`__staticDir/${multibookType}/games`).default;

  let games = new Map();
  _.chain(gamesData)
    .map((game) => {
      return games.set(`${game.id}`, game);
    })
    .value();

  const state = {
    games,
  };

  const getters = {
    games: (state) => {
      return state.games;
    },
    gameByID: (state) => {
      return (id) => {
        return state.games.get(`${id}`);
      };
    },
  };
  return { namespaced: true, state, getters };
};
